import { defineStore } from "pinia";
import { ref } from "vue";
import api from "@/utils/axios";

export const usePermissionStore = defineStore("permissionStore", ()=> {
    const permissions = ref([]);
    const loading = ref(false);
    const error = ref(null);

    const fetchPermissions = async () =>{
        loading.value = true;
        error.value = null;
        try{
            const response = await api.get("/permissions")
            const payload = response.data?.data;
            permissions.value = Array.isArray(payload)
                ? payload
                : Array.isArray(payload?.data) ? payload.data : [];
            return response.data;
        }catch(err){
            error.value = err.response?.data?.message || "Gagal Memuat Data Permission";
            throw err;
        }finally {
            loading.value=false;
        }
    };

    const createPermission = async (payload) => {
        loading.value = true;
        error.value = null;
        try {
            const response = await api.post("/permissions", payload);
            await fetchPermissions();
            return response.data;
        } catch (err) {
            error.value = err.response?.data?.message || "Gagal menambah permission";
            throw err;
        } finally {
            loading.value = false;
        }
    };

    const updatePermission = async (id, payload) => {
        loading.value = true;
        error.value = null;
        try {
            const response = await api.put(`/permissions/${id}`, payload);
            await fetchPermissions();
            return response.data;
        } catch (err) {
            error.value = err.response?.data?.message || "Gagal mengubah permission";
            throw err;
        } finally {
            loading.value = false;
        }
    };

    const deletePermission = async (id) => {
        loading.value = true;
        error.value = null;
        try {
            const response = await api.delete(`/permissions/${id}`);
            await fetchPermissions();
            return response.data;
        } catch (err) {
            error.value = err.response?.data?.message || "Gagal menghapus permission";
            throw err;
        } finally {
            loading.value = false;
        }
    };

    return {
        permissions,
        loading,
        error,
        fetchPermissions,
        createPermission,
        updatePermission,
        deletePermission,
    }
})
